import React from 'react'

const Heading = () => {
  return (
      <div className='flex items-center justify-center h-full'>
          <h3 className='pb-2 text-lg font-semibold'>Discover My Work Showcase</h3>
    </div>
  )
}

export default Heading